module.exports = "<ngx-ui-loader fgsType=\"rectangle-bounce\"></ngx-ui-loader>\n<router-outlet></router-outlet>\n<app-home></app-home>"